<template>
  <v-layout row justify-center>
    <v-dialog fullscreen v-model="dialog" persistent>
      <template #activator="{attrs}">
        <v-btn
          :loading="loading"
          v-bind="attrs"
          @click="OpenDialog"
          icon
          color="primary"
          dark
        >
          <v-icon>fas fa-info-circle</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="error white--text"
          >{{ Order.CostName }}: {{ Order.code }}
          <v-spacer></v-spacer>
          <v-btn dark icon @click.native="dialog = false"
            ><v-icon>fas fa-times</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text>
          <!-- {{ Order }} -->
          <v-data-table
            :headers="headers"
            :items="Transactions"
            :loading="loading"
            :search="search"
            :item-class="RowClass"
            :items-per-page="itemPerPage"
          >
            <template v-slot:top>
              <v-toolbar flat color="grey lighten-4">
                <v-spacer></v-spacer>
                <v-text-field
                  solo
                  dense
                  class="mt-5"
                  name="SearchText"
                  label="SEARCH BOX"
                  id="Searchid"
                  v-model.trim="search"
                ></v-text-field>

                <v-btn
                  v-if="Transactions.length"
                  icon
                  class="d-print-none"
                  @click="PrintPage"
                  small
                  color="success"
                >
                  <v-icon>fas fa-print</v-icon>
                </v-btn>
              </v-toolbar>
            </template>

            <template v-slot:[`item.qty`]="{ item }">
              {{ parseInt(item.qty).toLocaleString() }}
              <span>{{ item.UnitType }}</span>
              <span class="error--text font-weight-bold">{{
                item | DecmalQTY()
              }}</span>
            </template>

            <template v-slot:[`item.QTYOUT`]="{ item }">
              {{ parseInt(item.QTYOUT).toLocaleString() }}
              <span>{{ item.UnitType }}</span>
              <span class="error--text font-weight-bold">{{
                item | DecmalQTY("QTYOUT")
              }}</span>
            </template>

            <template v-slot:[`item.remailQty`]="{ item }">
              {{ parseInt(item.remailQty).toLocaleString() }}
              <span>{{ item.UnitType }}</span>
              <span class="error--text font-weight-bold">
                {{ item | DecmalQTY("remailQty") }}
              </span>
            </template>

            <template v-slot:[`item.cost`]="{ item }">
              {{ item.cost && item.cost.toLocaleString() }}
            </template>
            <template v-slot:[`item.price`]="{ item }">
              <!-- {{ item.price && item.price.toLocaleString() }} -->
              {{ item | profitPrice }}
            </template>
            <template v-slot:[`item.avgPrice`]="{ item }">
              {{ item | ActualProfit }}
            </template>
            <template v-slot:[`item.edite`]="{ item }">
              <price-edite
                v-if="AllowEdit"
                :key="'edite' + item.product"
                :EditeItems="item"
                :OnFinish="OpenDialog"
              ></price-edite>
              <SoldItemView :item="item"></SoldItemView>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { EventBus } from "@/main";
export default {
  components: {
    PriceEdite: () => import("./priceEdite"),
    SoldItemView: () => import("./SoldItemInfo"),
  },
  props: {
    Order: [Object],
    AllowEdit: {
      type: Boolean,
      default: true,
    },
  },
  filters: {
    DecmalQTY(item, key = "qty") {
      //   console.log(v);
      const unit = Math.round((item[key] - parseInt(item[key])) * item.UnitQty);
      if (unit > 0) return ` ${unit} PCS`;
    },
    profitPrice({ cost, price }) {
      let PROFIT = ((price / cost - 1) * 100).toFixed(1);
      return price.toLocaleString() + ` (${PROFIT}%)`;
    },
    ActualProfit({ cost, avgPrice }) {
      let PROFIT = ((avgPrice / cost - 1) * 100).toFixed(1);
      return avgPrice.toLocaleString() + ` (${avgPrice && PROFIT}%)`;
    },
  },
  data() {
    return {
      BaseURL: "/stock",
      search: "",
      dialog: false,
      loading: false,
      itemPerPage: 10,
      Transactions: [],
      headers: [
        {
          text: "Gategory",
          align: "left",
          value: "AccountName",
        },
        { text: "ITEM", value: "InvName" },
        { text: "QTY(IN)", value: "qty" },
        { text: "QTY(OUT)", value: "QTYOUT" },
        { text: "QTY(Remain)", value: "remailQty" },
        { text: "COST", value: "cost" },
        { text: "PRICE", value: "price" },
        { text: "AVG(SELL PRICE)", value: "avgPrice" },
        { text: "EDITE", value: "edite" },
        // { text: "Ref", value: "Ref" }
      ],
    };
  },
  methods: {
    // async PrintPage() {
    //   this.itemPerPage = this.Transactions.length;
    //   await EventBus.Printing(false);
    //   window.print();
    //   EventBus.Printing(true);
    //   this.itemPerPage = 10;
    // },
    RowClass(item) {
      if (item.cost > item.avgPrice && item.cost > item.price)
        return "error darken-4 white--text";
      else if (item.cost > item.price) return "warning darken white--text";
      else if (item.cost > item.avgPrice) return "error darken-2 white--text";
      else if (item.remailQty < 1) return "teal white--text";
      return "";
    },
    async PrintPage() {
      this.itemPerPage = this.Transactions.length;
      await EventBus.Printing(false);
      window.print();
      EventBus.Printing(true);
      this.itemPerPage = 10;
    },
    ReqDetail() {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: this.BaseURL + "/detail",
        query: { OredeCode: this.Order.code },
      });
    },
    OpenDialog() {
      this.loading = true;

      this.ReqDetail()
        .then(result => {
          this.dialog = true;
          this.loading = false;
          this.Transactions = result.data;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
  },
};
</script>
